import { render } from "./StoreDetail.vue?vue&type=template&id=37d4f15c&scoped=true"
import script from "./StoreDetail.vue?vue&type=script&lang=js"
export * from "./StoreDetail.vue?vue&type=script&lang=js"

import "./StoreDetail.vue?vue&type=style&index=0&id=37d4f15c&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d4f15c"]])

export default __exports__